export default [
    {
        path: '/website/redirect',
        props: true,
        component: () => import('@/views/WebsiteRedirect'),
    },
];
